export default "__VITE_ASSET__BXIFYdjG__"